import { Component, inject, signal } from '@angular/core'
import { RouterModule } from '@angular/router'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { resolveInitialLang } from '@services/language.util'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [RouterModule, TranslateModule],
})
export class HeaderComponent {
  private translate = inject(TranslateService)

  currentLanguage = signal<string>(resolveInitialLang())
  currentFlag = signal(this.currentLanguage() === 'sr' ? 'assets/images/sr.png' : 'assets/images/us.png')
  isMenuOpen = signal(false)
  isServicesOpen = signal(false)
  isLangOpen = signal(false)

  constructor() {
    const lang = this.currentLanguage()
    this.translate.use(lang)
    document.documentElement.lang = lang
  }

  toggleMenu(): void {
    this.isMenuOpen.update(v => !v)
    this.isServicesOpen.set(false)
    this.isLangOpen.set(false)
  }

  closeMenu(): void {
    this.isMenuOpen.set(false)
    this.isServicesOpen.set(false)
    this.isLangOpen.set(false)
  }

  toggleServices(event: Event): void {
    event.preventDefault()
    this.isServicesOpen.update(v => !v)
    this.isLangOpen.set(false)
  }

  toggleLang(event: Event): void {
    event.preventDefault()
    this.isLangOpen.update(v => !v)
    this.isServicesOpen.set(false)
  }

  switchLanguage(lang: string, event: Event): void {
    event.preventDefault()
    this.currentLanguage.set(lang)
    this.translate.use(lang)
    localStorage.setItem('lang', lang)
    document.documentElement.lang = lang
    this.currentFlag.set(lang === 'sr' ? 'assets/images/sr.png' : 'assets/images/us.png')
    this.isLangOpen.set(false)
    this.closeMenu()
  }
}
